














// @ is an alias to /src

import { Component, Vue } from 'vue-property-decorator';

import BgStep from '@/assets/BG-Step.svg';
import Dashboard from './dashboard.vue';
import { NavbarCustomerSelectionItem } from '@step/vue';
import { apiService, customerService } from '@/container';
import { configuration } from '@/configuration';

@Component({
  components: {
    Dashboard
  }
})
export default class DashboardReadOnly extends Vue {

  bgStep = BgStep;

  async created() {
    var idCustomer = this.$route.params.id;
    const app = 'Dashboard';
    const userCustomers = await apiService.post<ICustomerItem[]>('customer', 'userCustomers', { App: app },
      {
        axiosConfig: {
          baseURL: configuration.authBackendBaseUrl
        }
      });
    const customers = userCustomers.map<NavbarCustomerSelectionItem>(c => new NavbarCustomerSelectionItem(c.BusinessName, c.Id));
    const customer = customers.find(c => c.Id.toLowerCase() === idCustomer.toLowerCase());
    if (customer !== undefined) {
      customerService.setCustomer(customer.Id, customer.Name);
    }
  }
}
interface ICustomerItem {
  Id: string;
  BusinessName: string;
}
